// extracted by mini-css-extract-plugin
export default {"BreakpointDesktop":"Frame_BreakpointDesktop__1EfNH","ContentScreenStyling":"Frame_ContentScreenStyling__x++so","ContentScreen":"Frame_ContentScreen__gYgO1"};